import React from 'react';
import styles from './Button.module.css';

const VARIANT_CLASS = {
    primary: 'primary',
    outline: 'outline',
    secondary: 'secondary',
    success: 'success',
    danger: 'danger',
    text: 'text',
    gold: 'gold',
    dangerSoft: 'dangerSoft',
};

export default function Button({
    variant = 'primary',
    size,
    type = 'button',
    disabled,
    onClick,
    children,
    className,
    ...rest
}) {
    const variantClass = styles[VARIANT_CLASS[variant] || VARIANT_CLASS.primary];

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            className={`${styles.button} ${variantClass} ${size === 'small' ? styles.small : ''} ${className || ''}`}
            {...rest}
        >
            {children}
        </button>
    );
}
